module.exports = __webpack_public_path__ + "img/dance-work-icon2.f856e127.png";